export const INIT_NOTIFICATION_MUTATION = 'INIT_NOTIFICATION_MUTATION';
export const HIDE_NOTIFICATION_MUTATION = 'HIDE_NOTIFICATION_MUTATION';
